<template>
  <pack>
    <zt-title>
      {{info.app_name}}
      <zt-button class="fr back-btn" @click="back">返回</zt-button>
    </zt-title>
    <template v-if="info.status==0">
      <el-form label-position="left" label-width="120px">
        <el-form-item required label="App名称">
          <zt-input v-model="info.app_name" disabled placeholder="最多15个汉字"></zt-input>
        </el-form-item>

        <el-form-item required label="百川 App_key ">
          <zt-input v-model="info.baichuan_app_key" disabled></zt-input>
        </el-form-item>

        <el-form-item label="iOS Bundle ID">
          <zt-input v-model="info.ios_bundle_id" disabled></zt-input>
          <zt-button type="text" class="copy" v-copy="info.ios_bundle_id">复制</zt-button>
        </el-form-item>

        <el-form-item label="安卓包名">
          <zt-input v-model="info.android_package_name" disabled></zt-input>
          <zt-button type="text" class="copy" v-copy="info.android_package_name">复制</zt-button>
        </el-form-item>

        <!-- <el-form-item label="安卓签名">
          <zt-input disabled></zt-input>
          <zt-button type="text" class="copy" v-copy="copyText">复制</zt-button>
        </el-form-item>-->

        <el-form-item label="安卓市场渠道">
          <div class="market" v-for="(item,idx) in marketList" :key="idx">
            <span class="market-name">{{item.market}}</span>
            <zt-input v-model="item.ver" disabled></zt-input>
            <el-upload
              action
              class="upload-demo"
              ref="upload"
              :on-change="(file)=> { handleUploadchange(item,file,idx) }"
              :auto-upload="false"
            >
              <el-progress
                color="#B27DFF"
                type="circle"
                :width="30"
                :percentage="progressList[idx]"
                v-if="progressList[idx]===0||progressList[idx]"
              ></el-progress>
              <zt-button
                slot="trigger"
                class="download"
                :disabled="progressState[idx]==1"
              >{{progressState[idx]===1?'上传中':progressState[idx]===2?'上传失败':'上传安装包'}}</zt-button>
            </el-upload>
            <a :href="item.link" target="_blank" class="link">前往市场官网</a>
          </div>
        </el-form-item>

        <el-form-item label="iOS渠道">
          <div class="market">
            <span class="market-name">applestore</span>
            <zt-input v-model="appStoreData.ver" disabled></zt-input>
            <el-upload
              action
              class="upload-demo"
              ref="upload"
              :on-change="(file)=> { handleUploadIosChange(appStoreData,file) }"
              :auto-upload="false"
            >
              <el-progress
                color="#B27DFF"
                type="circle"
                :width="30"
                :percentage="iosProgress"
                v-if="iosProgress===0||iosProgress"
              ></el-progress>
              <zt-button
                slot="trigger"
                class="download"
                :disabled="iosProgressState==1"
              >{{iosProgressState==1?'上传中':iosProgressState==2?'上传失败':'上传安装包'}}</zt-button>
            </el-upload>
            <a href="https://developer.apple.com/" target="_blank" class="link">前往市场官网</a>
          </div>
        </el-form-item>

        <el-form-item label="App图标" class="upload">
          <upload :src="info.app_icon" text="更换图标" @changeUrl="changeUrl" :disabled="true"></upload>
          <zt-button type="text" @click="downloadIcon(info.app_icon)">点击下载</zt-button>
        </el-form-item>

        <el-form-item>
          <zt-button type="primary" class="finish" @click="finish">开发完成</zt-button>
          <!-- <zt-button class="save" v-if="info.status==0">保存</zt-button> -->
        </el-form-item>
      </el-form>
    </template>

    <template v-else>
      <el-tabs v-model="active" ref="tabs">
        <el-tab-pane label="基本配置" name="0">
          <base-config @updata="getAppInfo" :info="info"></base-config>
        </el-tab-pane>
        <el-tab-pane label="个性设置" name="1">
          <personal-config :info="info"></personal-config>
        </el-tab-pane>
        <el-tab-pane label="版本更新" name="2">
          <edition-history :historyList="historyList"></edition-history>
        </el-tab-pane>
        <el-tab-pane label="审核模式" name="3">
          <examine :examineList="examineList"></examine>
        </el-tab-pane>
      </el-tabs>
    </template>
  </pack>
</template>

<script>
import { copy } from '@/directive/copy';
import upload from '@cps/Upload/upload';
import { download } from '@/utils/download';
import baseConfig from './components/baseConfig';
import personalConfig from './components/personalConfig';
import editionHistory from './components/editionHistory';
import examine from './components/examine';
import { post } from '@/utils/request';
import {
  admin_plugin_app_info,
  // admin_plugin_app_upload,
  admin_plugin_app_set
} from '@/api/appAdminManage';

export default {
  directives: { copy },
  components: {
    upload,
    baseConfig,
    personalConfig,
    editionHistory,
    examine,
  },
  data: () => ({
    info: {
      status: 0,
    },
    iosProgress: '',
    iosProgressState: '',
    progressState: [],
    progressList: [],
    appStoreData: {},
    linkList: {
      360: 'http://dev.360.cn/',
      应用宝: 'http://op.open.qq.com/',
      小米: 'https://dev.mi.com/console/',
      华为: 'http://developer.huawei.com/',
      oppo: 'http://open.oppomobile.com/',
      vivo: 'https://id.vivo.com.cn/',
    },
    historyList: {
      androidList: [],
      iosList: [],
    },
    examineList: [],
    marketList: [],
    active: 0,
    id: '',
  }),
  methods: {
    finish() {
      let error = false;
      this.marketList.map((arr) => {
        if (!arr.ver && !error) {
          error = true;
          return this.$message.error(`请上传${arr.market}渠道安装包`);
        }
      });
      if (!this.appStoreData.ver && !error) {
        error = true;
        return this.$message.error('请上传iOS渠道安装包');
      }
      if (error) return;
      this.$confirm('确定更改开发状态？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          admin_plugin_app_set({
            id: this.id,
            status: 1,
          }).then(({ data }) => {
            if (data.error_code == 0) {
              this.$message.success('成功修改开发状态');
              this.getAppInfo();
            } else {
              this.$message.error(data.error_message);
            }
          });
        })
        .catch(() => {});
    },
    handleUploadchange(item, file, idx) {
      let that = this;
      post(
        'admin_plugin_app_upload',
        {
          id: this.info.id,
          market: item.market,
          appfile: file.raw,
        },
        {
          clear: false,
          config: {
            timeout: 100000,
            transformRequest: [
              (data) => {
                // data => formdata
                let formD = new FormData();
                Object.keys(data).forEach((key) => {
                  if (data[key] !== null) {
                    formD.append(key, data[key]);
                  }
                });
                return formD;
              },
            ],
            onUploadProgress: (progressEvent) => {
              var complete =
                ((progressEvent.loaded / progressEvent.total) * 100) | 0;
              that.progressList.splice(idx, 1, complete);
              that.progressState.splice(idx, 1, 1);
              console.log(that.progressState);
            },
          },
        }
      )
        .then(({ data }) => {
          this.progressState.splice(idx, 1, 0);
          if (data.error_code == 0) {
            this.$message.success('上传成功');
            this.getAppInfo();
          } else {
            if (data.error_code == 5) {
              this.progressList = [];
              this.progressState = [];
            }
            this.$message.error(data.error_message);
          }
        })
        .catch((e) => {
          console.log(e);
          this.progressState.splice(idx, 1, 2);
        });
      // admin_plugin_app_upload({
      //   id: this.info.id,
      //   market: item.market,
      //   appfile: file.raw
      // }).then(({ data }) => {
      //   if (data.error_code == 0) {
      //     this.$message.success("上传成功");
      //     this.$emit("updata")
      //   } else {
      //     this.$message.error(data.error_message);
      //   }
      // });
    },
    handleUploadIosChange(item, file) {
      let that = this;
      post(
        'admin_plugin_app_upload',
        {
          id: this.info.id,
          market: 'applestore',
          appfile: file.raw,
        },
        {
          clear: false,
          config: {
            timeout: 100000,
            transformRequest: [
              (data) => {
                // data => formdata
                let formD = new FormData();
                Object.keys(data).forEach((key) => {
                  if (data[key] !== null) {
                    formD.append(key, data[key]);
                  }
                });
                return formD;
              },
            ],
            onUploadProgress: (progressEvent) => {
              var complete =
                ((progressEvent.loaded / progressEvent.total) * 100) | 0;
              that.iosProgress = complete;
              that.iosProgressState = 1;
            },
          },
        }
      )
        .then(({ data }) => {
          that.iosProgressState = 0;
          if (data.error_code == 0) {
            this.$message.success('上传成功');
            this.$emit('updata');
            this.iosProgress = '';
            this.iosProgressState = '';
          } else {
            if (data.error_code == 5) {
              this.iosProgress = '';
              this.iosProgressState = '';
            }
            this.$message.error(data.error_message);
          }
        })
        .catch((e) => {
          console.log(e);
          this.iosProgress = 2;
        });
    },
    back() {
      this.$router.push({
        path: '/appAdminManage',
      });
    },
    convertImgToBase64(url, callback, outputFormat) {
      var canvas = document.createElement('CANVAS'),
        ctx = canvas.getContext('2d'),
        img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function() {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || 'image/png');
        callback.call(this, dataURL);
        canvas = null;
      };
      img.src = url;
    },
    changeUrl(url) {
      this.info.app_icon = url;
    },
    downloadIcon(src) {
      if (src == '') {
        this.$message.error('暂无app图标');
        return;
      }
      this.convertImgToBase64(src, function(base64) {
        download(base64, 'app图标.jpg');
      });
    },
    getAppInfo() {
      admin_plugin_app_info({
        id: this.id,
      }).then(({ data }) => {
        this.historyList = {
          androidList: [],
          iosList: [],
        };
        this.examineList = [];
        this.marketList = [];
        this.progressList = [];
        this.progressState = [];
        if (data.error_code == 0) {
          this.info = data.info;
          this.info.android_market.map((arr) => {
            this.progressState.push(0);
            this.progressList.push('');
            this.marketList.push({
              market: arr,
              link: this.linkList[arr],
            });
          });
          this.marketList.map((arr) => {
            this.info.appfiles.map((file) => {
              if (arr.market == file.market) {
                arr.ver = file.ver;
              }
            });
          });
          this.info.appfiles.map((arr) => {
            if (arr.market == 'applestore') {
              this.appStoreData = arr;
            }
          });
          this.info.version_history.map((arr) => {
            if (arr.market != 'applestore') {
              this.historyList.androidList.push(arr);
            } else {
              this.historyList.iosList.push(arr);
            }
            if (arr.apply == 1) {
              if (arr.market != 'applestore') {
                arr.sys = 'Android（安卓）';
              } else {
                arr.sys = 'iOS';
              }
              this.examineList.push(arr);
            }
          });
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
  },
  beforeRouteEnter(to, form, next) {
    to.meta.title = to.params.id.split('_')[1];
    next();
  },
  mounted() {
    this.id = this.$route.params.id.split('_')[0];
    this.getAppInfo();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-progress {
  position: absolute;
  top: 5px;
  left: 530px;
}
/deep/ .el-upload-list__item {
  display: none;
}
.upload-demo {
  display: inline-block;
}
.upload-hide {
  width: 0px;
  height: 0px;
}
.tips {
  color: $theme-textsecond;
  font-size: 12px;
  line-height: 12px;
  vertical-align: 5px;
}
.back-btn {
  width: 139px;
  height: 40px;
  border-radius: 2px;
  color: #b27dff;
  border: 1px solid rgba(178, 125, 255, 1);
}
/deep/ .zt-input {
  width: 511px;
}
/deep/ .el-checkbox-group {
  width: 170px;
}
.copy {
  margin-left: 10px;
}
.download {
  vertical-align: middle;
  width: 139px;
  height: 40px;
  border-radius: 2px;
  border: 1px solid $theme;
  display: inline-block;
  color: $theme;
  text-align: center;
  margin-left: 16px;
}
.link {
  vertical-align: middle;
  margin-left: 11px;
  color: $theme;
}
.market-name {
  display: inline-block;
  width: 80px;
  font-size: 14px;
  color: #232526;
}
.market {
  position: relative;
  margin-top: 16px;
}
.finish {
  width: 143px;
  height: 40px;
  margin-right: 24px;
}
.save {
  width: 143px;
  height: 40px;
  color: $theme;
  border-radius: 2px;
  border: 1px solid rgba(178, 125, 255, 1);
}
</style>